import { DistributionChannel } from 'model/DistributionChannel';
import { LogicDependencyMode } from 'model/LogicDependencyMode';
import { LogicType } from 'model/LogicType';

export type LogicDtoBase = {
  id?: number;
  type?: LogicType;
};

export type LogicClassificationDto = LogicDtoBase & {
  departments?: number[];
  classifications?: number[];
};

export type LogicDistributionDto = LogicDtoBase & {
  channel: DistributionChannel;
};

export type LogicDependencyDto = LogicDtoBase & {
  question: number;
  options?: number[];
  mode: number;
};

export type LogicClassificationModel = {
  id?: number;
  type: LogicType.Classification;
  departmentsIds?: number[];
  classificationsIds?: number[];
};

export type LogicDistributionModel = {
  id?: number;
  type: LogicType.Distribution;
  channel: DistributionChannel;
};

export type LogicDependencyModel = {
  id?: number;
  type: LogicType.Dependency;
  questionId: number;
  options?: number[];
  mode?: LogicDependencyMode;
};

export type LogicModel = LogicClassificationModel | LogicDistributionModel | LogicDependencyModel;

export namespace LogicModel {
  export function mapLogicDtoToModel(entry: LogicDtoBase): LogicModel {
    switch (entry.type) {
      case LogicType.Classification:
        return {
          id: entry.id,
          type: LogicType.Classification,
          departmentsIds: (entry as LogicClassificationDto).departments,
          classificationsIds: (entry as LogicClassificationDto).classifications,
        };
      case LogicType.Distribution:
        return {
          id: entry.id,
          type: LogicType.Distribution,
          channel: (entry as LogicDistributionDto).channel,
        };
      case LogicType.Dependency:
        return {
          id: entry.id,
          type: LogicType.Dependency,
          questionId: (entry as LogicDependencyDto).question,
          options: (entry as LogicDependencyDto).options || [],
          mode: (entry as LogicDependencyDto).mode,
        };
      default:
        throw new Error(`Unknown logic type: ${entry.type}`);
    }
  }

  export function mapLogicModelToDto(model: LogicModel): LogicDtoBase {
    switch (model.type) {
      case LogicType.Classification:
        return {
          type: model.type,
          departments: model.departmentsIds,
          classifications: model.classificationsIds,
        } as LogicClassificationDto;
      case LogicType.Distribution:
        return {
          type: model.type,
          channel: model.channel,
        } as LogicDistributionDto;
      case LogicType.Dependency:
        return {
          type: model.type,
          question: model.questionId,
          options: model.options || [],
          mode: model.mode || LogicDependencyMode.AllEqual,
        } as LogicDependencyDto;
      default:
        throw new Error(`Unknown logic type: ${(model as any).type}`);
    }
  }
}
